export default __webpack_public_path__ + "static/media/prisma.16923957.svg";